import { render } from "./_Units.vue?vue&type=template&id=5a8515a6"
import script from "./_Units.vue?vue&type=script&lang=js"
export * from "./_Units.vue?vue&type=script&lang=js"

import exportComponent from "C:\\AgentPools\\FAOAgentPool\\_work\\20\\s\\PESVue\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__